export const mockedGrades = [
    { externalId: "1", gradeName: "Informatica" },
    { externalId: "2", gradeName: "Matematicas" },
    { externalId: "3", gradeName: "Fisica" },
]